import { map } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { environment } from '../../../environments/environment';
import { FieldActivityProgram } from '../_models/fieldActivityProgram';
import { GeneralUtilsService } from './common/generalUtils.service';

@Injectable()
export class FieldActivityProgramService {
  private apiBaseUrl = environment.apiBaseUrl;
  programItemObj: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient,
    private generalUtilsService: GeneralUtilsService
  ) {}

  initProgramObj() {
    this.programItemObj = new BehaviorSubject<any>(null);
  }

  getFieldActivityPrograms(): Observable<FieldActivityProgram[]> {
    return this.http
      .get<FieldActivityProgram[]>(this.apiBaseUrl + 'api/private/v1/fieldActivityPrograms')
      .pipe(map((response) => response));
  }

  getFieldActivityProgramByType(type): Observable<FieldActivityProgram[]> {
    return this.http
      .get<
        FieldActivityProgram[]
      >(this.apiBaseUrl + 'api/private/v1/fieldActivityPrograms?type=' + type)
      .pipe(map((response) => response));
  }

  getFieldActivityProgram(id: number): Observable<FieldActivityProgram> {
    return this.http
      .get<FieldActivityProgram>(this.apiBaseUrl + 'api/private/v1/fieldActivityPrograms/' + id)
      .pipe(map((response) => response));
  }

  saveFieldActivityProgram(fieldActivityPlanItem): Observable<FieldActivityProgram> {
    const fieldActivityProgram = { ...fieldActivityPlanItem };
    delete fieldActivityProgram.lastUpdated;
    delete fieldActivityProgram.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    fieldActivityProgram.companyId = companySelected ? companySelected.id : null;

    if (fieldActivityProgram.user != null && fieldActivityProgram.user.id != null) {
      fieldActivityProgram.user = { id: fieldActivityProgram.user.id };
    }
    if (fieldActivityProgram.id) {
      return this.http
        .put<FieldActivityProgram>(
          this.apiBaseUrl + 'api/private/v1/fieldActivityPrograms/' + fieldActivityProgram.id,
          fieldActivityProgram
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<FieldActivityProgram>(
          this.apiBaseUrl + 'api/private/v1/fieldActivityPrograms',
          fieldActivityProgram
        )
        .pipe(map((response) => response));
    }
  }

  deleteFieldActivityProgram(
    fieldActivityProgram: FieldActivityProgram
  ): Observable<FieldActivityProgram> {
    return this.http
      .delete(this.apiBaseUrl + 'api/private/v1/fieldActivityPrograms/' + fieldActivityProgram.id)
      .pipe(
        map((response) => {
          return { id: fieldActivityProgram.id } as FieldActivityProgram;
        })
      );
  }

  sumColumnByKey = (list: Array<any>, key: string): number => {
    // tslint:disable-next-line:prefer-const
    let sum = 0;
    if (list && list.length > 0) {
      list.forEach((cost) => {
        if (key === 'quantity') {
          sum = sum + cost.quantity;
        }
      });

      return sum;
    }
  };

  getTotalPriceByUnit = (quantity: number, unitPrice: number): number => {
    quantity = quantity ? quantity : 0;
    unitPrice = unitPrice ? unitPrice : 0;
    return quantity * unitPrice;
  };

  getDiscountAmount = (cost: number, discount: number): number => {
    cost = cost ? cost : 0;
    discount = discount ? discount : 0;
    return (cost * discount) / 100;
  };

  checkIfCheckBoxIsSelected = (AllListProgram, cropProgramList) => {
    let arrayList = [];
    arrayList = this.generalUtilsService.addSelectedParam(AllListProgram, false);
    arrayList.forEach((program) => {
      if (program && program.activities && program.activities.length > 0) {
        program.activities = this.generalUtilsService.addSelectedParam(program.activities, false);
      }
    });
    if (cropProgramList) {
      arrayList.forEach((program) => {
        program.selected = _.find(cropProgramList, { id: program.id });
        if (program && program.activities && program.activities.length > 0) {
          program.activities.forEach((activity) => {
            activity.selected = this.findActivitiesInProgram(activity, cropProgramList);
          });
        }
      });
    }
    return arrayList;
  };

  findActivitiesInProgram = (activity, cropProgramList) => {
    let count = 0;
    cropProgramList.forEach((program) => {
      if (program && program.activities && program.activities.length > 0) {
        if (_.find(program.activities, { uuid: activity.uuid })) {
          count++;
        }
      }
    });
    if (count > 0) {
      return true;
    } else {
      return false;
    }
  };
}
